import React, { useState, useEffect } from "react";

const MarketingHeader = () => {
  const announcements = [
    "FREE SHIPPING on all Orders in Australia till Nov 30",
    "20% OFF on all items this weekend",
    "New collection arriving soon!",
  ];
  
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (announcements.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === announcements.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [announcements.length]);

  if (!announcements.length) return null;

  return (
    <div className="bg-black text-white py-1 text-center font-['Inconsolata'] font-bold text-[18px] leading-[28.32px]">
      {announcements[currentIndex]}
    </div>
  );
};

export default MarketingHeader;
